import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-m-button-gradient',
  templateUrl: './m-button-gradient.component.html',
  styleUrls: ['./m-button-gradient.component.scss'],
})
export class MButtonGradientComponent implements OnInit {
  @Input() text: string;
  @Input() isDisabled: boolean;
  @Input() size: string = "large";
  @Input() noMargin: boolean;
  constructor() { }

  ngOnInit() {}

}
